import providerUtils from 'app-lib/providerUtils'
import { ChainId } from 'bzx-common/src/config/chains/chainCommon'
import ContractsSource from 'bzx-common/src/contracts/ContractsSource'
import { IProviderEvents } from 'bzx-common/src/domain/events'
import { ProviderType } from 'bzx-common/src/domain/ProviderTypeDictionary'
import Web3ConnectionFactory from 'bzx-common/src/services/Web3ConnectionFactory'
import { providers } from 'ethers5'
import { TypedEmitter } from 'tiny-typed-emitter'
import { Web3ProviderEngine } from '@0x/subproviders'
import { Web3Wrapper } from '@0x/web3-wrapper'

export class FulcrumProvider extends TypedEmitter<IProviderEvents> {
  public impersonateAddress = localStorage.getItem('impersonateAddress') || ''
  public providerType: ProviderType = ProviderType.None
  public providerEngine: Web3ProviderEngine | null = null
  public web3Wrapper: Web3Wrapper | null = null
  public contractsSource: ContractsSource | null = null
  public accounts: string[] = []
  public get currentAccount(): string {
    return providerUtils.getCurrentAccount(this)
  }

  public get currentChainId() {
    return Web3ConnectionFactory.networkId as ChainId
  }

  public get ethersProvider(): providers.BaseProvider {
    return Web3ConnectionFactory.etherProvider
  }

  constructor() {
    super()
    this.setMaxListeners(1000)
  }
}

export default new FulcrumProvider()
